import {api, paramEncoder} from "./repository";
const resource = "/updates";

export default {
    getAll(params) {
        return api.get(`${resource}${paramEncoder(params)}`);
    },
    store(payload) {
        return api.post(resource, payload);
    },
    getById(id, params) {
        return api.get(`${resource}/${id}${paramEncoder(params)}`);
    },
    update(payload) {
        let id = payload.id;
        return api.put(`${resource}/${id}`, payload);
    },
    destroy(id) {
        return api.delete(`${resource}/${id}`);
    }
}